import { render, staticRenderFns } from "./SawView.vue?vue&type=template&id=65706fa2"
import script from "./SawView.vue?vue&type=script&lang=js"
export * from "./SawView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports